import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { InterfaceMappingService } from '../../../service/interface-mapping/interface-mapping.service';
import { config } from '../../../util/config';

@Component({
  selector: 'wa0052',
  templateUrl: 'wa0052.component.html',
  styleUrls: ['wa0052.component.scss']
})
export class Wa0052Component implements OnInit {
  public componentTitle = 'WA0052:データマッピング(定義作成2)';

  private ownerId: number;
  private ownerResult: any;

  private working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public config = config;
  private production = environment.production;
  private backgroundColor: string;
  private updprogramCd = 'wa0052';
  private rowDatas: any[];
  private rowDatasCls = [];

  private uploadobjects;
  private uploadobjects_objectname;
  private uploadfilename;
  private uploadpattern;

  private patternRowDatas;

  private patternName = '';
  private patternNames: any[] = [];
  private patternNameCheck = false;

  private modeMappingPattern;

  private rdata: any[] = [];
  private rowdata: any[] = [];

  private readDatas: any[] = [];

  private loadStartAt: number = undefined;
  private attention = '';
  private uploadObjectId;
  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  @ViewChild('scrollContent')
  scrollContent: ElementRef;

  private patternNameCls = '';
  private loadStartAtCls = '';
  private isSubmitButtonEnabled = false;
  private isShowFloatDesc = false;
  private isShowSendLoading = false;
  private isShowInStockModal = false;
  constructor(private interfaceMappingService: InterfaceMappingService, private commonService: CommonService, private router: Router, private dialogsService: DialogsService) {
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }

    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  ngOnInit() {
    this.registerLayoutContentScrollListener();
    setTimeout(() => {
      // this.onResize(null);
    }, 500);
  }

  onView() {
    this.isShowSendLoading = true;

    // アップロード種別
    if (sessionStorage.getItem('uploadobjects') !== null) {
      this.uploadobjects = JSON.parse(sessionStorage.getItem('uploadobjects'));
      this.uploadobjects_objectname = this.uploadobjects.objectName;
      this.attention = this.uploadobjects.attention;
      this.uploadObjectId = this.uploadobjects.uploadObjectId;
      console.log(this.attention);
    } else {
      /*
      this.dialogsService.info('エラー', 'マッピング種別が認識出来ません。').subscribe(res => {
        if (res === true) {
          this.router.navigate(['wa0050']);
        }
      });
      */
      this.errorInfo = 'マッピング種別が認識出来ません。';
      this.router.navigate(['wa0051']);
      return;
    }

    // ファイル名
    this.uploadfilename = sessionStorage.getItem('uploadfilename');

    // マッピングパターン
    this.modeMappingPattern = sessionStorage.getItem('modeMappingPattern');

    // 定義ファイル名リスト取得
    const id = this.uploadobjects.uploadObjectId;
    this.interfaceMappingService
      .get_patternnames(id)
      .then(outputJson => {
        this.patternNames = outputJson.patternnames;
      })
      .catch(error => {
        this.isShowSendLoading = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
        return;
      });

    // マッピングパターンが、読み込み(1)の場合、登録されたマッピングを読み込む
    if (this.modeMappingPattern === '1') {
      // 定義ファイル読み込み
      if (sessionStorage.getItem('uploadpattern') !== null) {
        this.uploadpattern = JSON.parse(sessionStorage.getItem('uploadpattern'));
      }
      this.interfaceMappingService
        .get_patternmappings(this.uploadpattern.uploadObjectsPatternId, this.uploadobjects.uploadObjectId)
        .then(outputJson => {
          this.isShowSendLoading = false;
          this.patternRowDatas = outputJson.patternsmappings;

          this.interfaceMappingService
            .uploaditems(this.uploadobjects.uploadObjectId)
            .then(outputJson => {
              this.isShowSendLoading = false;
              this.resetSelectCls(outputJson.uploaditems.length);
              this.rowDatas = outputJson.uploaditems;
              this.createSelect();
            })
            .catch(error => {
              this.isShowSendLoading = false;
              this.errorInfo = this.commonService.getErrorMessage(error);
            });
        })
        .catch(error => {
          this.isShowSendLoading = false;
          this.errorInfo = this.commonService.getErrorMessage(error);
          return;
        });
    } else {
      this.interfaceMappingService
        .uploaditems(this.uploadobjects.uploadObjectId)
        .then(outputJson => {
          this.isShowSendLoading = false;
          this.resetSelectCls(outputJson.uploaditems.length);
          this.rowDatas = outputJson.uploaditems;
          this.createSelect();
        })
        .catch(error => {
          this.isShowSendLoading = false;
          this.errorInfo = this.commonService.getErrorMessage(error);
        });
    }
  }

  resetSelectCls(len) {
    for (let i = 0; i < len; i++) {
      this.rowDatasCls[i] = '';
    }
  }

  onupload(selectedOwnerId) {
    console.log(selectedOwnerId);
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
    } else {
    }
  }

  onResize(event) {
    const documentHeight =
      document.getElementById('tmain').clientHeight +
      document.getElementById('ttitle').clientHeight +
      document.getElementById('tline').clientHeight +
      document.getElementById('tmemo').clientHeight +
      document.getElementById('tcomponent').clientHeight;

    // console.log(documentHeight);

    this.containerHeight = documentHeight + 250 - config.containerheaderMargin;
    this.cardHeight = documentHeight + 250 - config.headerMargin;
  }

  onSubmit() {
    this.isShowSendLoading = true;
    // if (this.working === true) {
    //   return;
    // }

    // this.working = true;

    if (this.patternName === '') {
      this.isShowSendLoading = false;
      this.errorInfo = 'データマッピング定義名を指定してください。';
      this.scrollContent.nativeElement.scrollTop = 0;
      return;
    }

    if (this.patternNameCheck === false) {
      this.isShowSendLoading = false;
      this.errorInfo = 'データマッピング定義名が、重複しています。変更をしてください。';
      this.scrollContent.nativeElement.scrollTop = 0;
      return;
    }

    if (this.patternName.length > 63) {
      this.isShowSendLoading = false;
      this.errorInfo = 'データマッピング定義名が長すぎます。全角63文字まで登録可能です。';
      this.scrollContent.nativeElement.scrollTop = 0;
      return;
    }

    if (this.loadStartAt < 1 || this.loadStartAt === undefined) {
      this.isShowSendLoading = false;
      this.errorInfo = '読込行数設定は1以上を指定してください。';
      this.scrollContent.nativeElement.scrollTop = 0;
      return;
    }

    console.log(isFinite(this.loadStartAt));

    if (!isFinite(this.loadStartAt)) {
      this.isShowSendLoading = false;
      this.errorInfo = '読込行数設定は半角数字を指定してください。';
      this.scrollContent.nativeElement.scrollTop = 0;
      return;
    }

    if (this.loadStartAt > 256) {
      this.isShowSendLoading = false;
      this.errorInfo = '読込行数設定は256以下を指定してください。';
      this.scrollContent.nativeElement.scrollTop = 0;
      return;
    }
    this.isShowInStockModal = false;
    const mappings: any[] = [];

    let j = 0;
    for (let i = 0; i < this.rdata.length; i++) {
      // 0は未定義なので無視
      const array = {
        uploadItemId: this.rowDatas[i].uploadItemId,
        mappedColmun: (!isNaN(this.rdata[i]) && this.rdata[i] !== 0) ? this.rdata[i] - 1 : -1,
        uploadItemCode: this.rowDatas[i].uploadItemCode
      };
      mappings[j] = array;
      j++;
    }

    for (let k = 0; k < this.rowDatas.length; k++) {
      if (this.rowDatas[k].isNecessary === 1) {
        // 必須チェック付き
        const matchData = mappings.filter(function (item, index) {
          // tslint:disable-next-line:triple-equals
          if (item.uploadItemId == this) {
            //SW-1804 空欄が選択されていなかったらtrue
            if (item.mappedColmun !== -1 ) {
              return true;
            }
          }
        }, this.rowDatas[k].uploadItemId);

        if (matchData.length === 0) {
          this.isShowSendLoading = false;
          this.errorInfo = '必須項目が選択されていません。';
          this.scrollContent.nativeElement.scrollTop = 0;
          return;
        }
      }

      if (this.rowDatas[k].isNecessary === 2 && this.uploadobjects.objectCode === 'arriveplans') {
        // 入荷データ(arriveplans)
        // カートン数(caseNr)か、個数(pcsNr)のどちらかが必須
        const matchData_ship1 = mappings.filter(function (item, index) {
          // tslint:disable-next-line:triple-equals
          if (item.uploadItemCode == this) {
            //SW-1804 空欄が選択されていなかったらtrue
            if (item.mappedColmun !== -1 ) {
              return true;
            }
          }
        }, 'caseNr');

        const matchData_ship2 = mappings.filter(function (item, index) {
          // tslint:disable-next-line:triple-equals
          if (item.uploadItemCode == this) {
            //SW-1804 空欄が選択されていなかったらtrue
            if (item.mappedColmun !== -1 ) {
              return true;
            }
          }
        }, 'pcsNr');
        
        if ((matchData_ship1.length === 0) && (matchData_ship2.length === 0)) {
          this.isShowSendLoading = false;
          this.errorInfo = 'カートン数または個数のいずれかは必須です。カートン数または個数の項目を選択してください。';
          this.scrollContent.nativeElement.scrollTop = 0;
          return;
        }
      }

      if (this.rowDatas[k].isNecessary === 2 && this.uploadobjects.objectCode === 'ship') {
        // 出荷データ(ship)
        // 届先住所 届先コードを指定するか、届先名称、届先郵便番号、届先住所1を指定

        const matchData_ship1 = mappings.filter(function (item, index) {
          // tslint:disable-next-line:triple-equals
          if (item.uploadItemCode == this) {
            //SW-1804 空欄が選択されていなかったらtrue
            if (item.mappedColmun !== -1 ) {
              return true;
            }
          }
        }, 'dtaddressCd');

        if (matchData_ship1.length === 0) {
          // 届先コードがない

          // 届先名称
          const matchData_ship2 = mappings.filter(function (item, index) {
            // tslint:disable-next-line:triple-equals
            if (item.uploadItemCode == this) {
              //SW-1804 空欄が選択されていなかったらtrue
              if (item.mappedColmun !== -1 ) {
                return true;
              }
            }
          }, 'dtnameTx');
          // 届先郵便番号
          const matchData_ship3 = mappings.filter(function (item, index) {
            // tslint:disable-next-line:triple-equals
            if (item.uploadItemCode == this) {
              //SW-1804 空欄が選択されていなかったらtrue
              if (item.mappedColmun !== -1 ) {
                return true;
              }
            }
          }, 'dtpostalCd');
          // 届先住所1
          const matchData_ship4 = mappings.filter(function (item, index) {
            // tslint:disable-next-line:triple-equals
            if (item.uploadItemCode == this) {
              //SW-1804 空欄が選択されていなかったらtrue
              if (item.mappedColmun !== -1 ) {
                return true;
              }
            }
          }, 'dtaddress1Tx');
          // 届先電話番号
          const matchData_ship5 = mappings.filter(function (item, index) {
            if (item.uploadItemCode == this) {
              //SW-1804 空欄が選択されていなかったらtrue
              if (item.mappedColmun !== -1 ) {
                return true;
              }
            }
          }, 'dttelTx');

          if (matchData_ship2.length === 0 || matchData_ship3.length === 0 || matchData_ship4.length === 0 || matchData_ship5.length === 0) {
            this.isShowSendLoading = false;
            this.errorInfo = '届先コードを指定するか、届先名称、届先郵便番号、届先住所1、届先電話番号の項目を選択してください。';
            this.scrollContent.nativeElement.scrollTop = 0;
            return;
          }
        }
      }

      if (this.rowDatas[k].isNecessary === 3 && this.uploadobjects.objectCode === 'ship') {
        // 出荷データ(ship)
        // カートン数(shipcaseNr)か、個数(shipbaraNr)のどちらかが必須

        const matchData_ship1 = mappings.filter(function (item, index) {
          // tslint:disable-next-line:triple-equals
          if (item.uploadItemCode == this) {
            //SW-1804 空欄が選択されていなかったらtrue
            if (item.mappedColmun !== -1 ) {
              return true;
            }
          }
        }, 'shipcaseNr');

        const matchData_ship2 = mappings.filter(function (item, index) {
          // tslint:disable-next-line:triple-equals
          if (item.uploadItemCode == this) {
            //SW-1804 空欄が選択されていなかったらtrue
            if (item.mappedColmun !== -1 ) {
              return true;
            }
          }
        }, 'shipbaraNr');

        if (matchData_ship1.length === 0 && matchData_ship2.length === 0) {
          this.isShowSendLoading = false;
          this.errorInfo = 'カートン数または個数のいずれかは必須です。カートン数または個数の項目を選択してください。';
          this.scrollContent.nativeElement.scrollTop = 0;
          return;
        }
      }
    }

    const owners = sessionStorage.getItem('uploadpatternowners');
    const jsonInput = {
      uploadObjectId: this.uploadobjects.uploadObjectId,
      patternName: this.patternName,
      loadStartAt: this.loadStartAt,
      mappings: mappings,
      ownerIdList: JSON.parse(owners)
    };

    this.interfaceMappingService
      .post_patternmappings(jsonInput)
      .then(outputJson => {
        this.isShowSendLoading = false;
        /*
        this.dialogsService.info('完了', 'データマッピング定義の保存が完了しました。').subscribe(res => {
          if (res === true) {
            this.working = true;
          }
        });
        */
        sessionStorage.setItem('SuccessInfoMessage', 'データマッピング定義の保存が完了しました。');
        this.scrollContent.nativeElement.scrollTop = 0;
        this.isShowSendLoading = true;
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.isShowSendLoading = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.scrollContent.nativeElement.scrollTop = 0;
      });
  }

  createSelect() {
    this.readDatas[0] = undefined;
    for (let i = 0; i < this.interfaceMappingService.data2json_viewjson.length; i++) {
      this.readDatas[i + 1] = this.to_string_col_index(i + 1) + '列: [' + this.interfaceMappingService.data2json_viewjson[i] + ']';
    }
    if (this.modeMappingPattern === '1') {
      for (let i = 0; i < this.rowDatas.length; i++) {
        if (this.patternRowDatas[i].mappedColmun !== null) {
          this.rdata[i] = this.patternRowDatas[i].mappedColmun + 1;
        } else {
          this.rdata[i] = '';
        }
      }
    }
  }

  // 1からAに変換
  // 26でZ、27でAAに
  to_string_col_index(numeric_col_index) {
    let n = numeric_col_index;
    let s = '';
    while (n >= 1) {
      n--;
      s = String.fromCharCode('A'.charCodeAt(0) + (n % 26)) + s;
      n = Math.floor(n / 26);
    }
    return s;
  }

  checkPatternName() {
    const matchData = this.patternNames.filter(function (item, index) {
      // tslint:disable-next-line:triple-equals
      if (item.patternName == this) {
        return true;
      }
    }, this.patternName);

    if (matchData.length === 1) {
      this.errorInfo = '同一のデータマッピング定義名が既に登録済みです。変更してください。';
      this.patternNameCheck = false;
    } else {
      this.errorInfo = '';
      this.patternNameCheck = true;
    }
  }

  cancel() {
    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    } else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    this.patternName = '';
    this.loadStartAt = null;
    this.errorInfo = '';
    this.rdata = [];
    this.rowdata = [];
    this.rowDatasCls = [];
    this.readDatas = [];

    setTimeout(() => {
      this.scrollContent.nativeElement.scrollTop = 0;
    }, 200);
    this.onView();
  }

  ngDoCheck() {
    if (!this.isShow || this.rowDatas == null) return;

    this.patternNameCls = this.patternName != null && this.patternName.length > 0 ? 'active' : '';
    this.loadStartAtCls = this.loadStartAt != null && this.loadStartAt >= 1 ? 'active' : '';

    var isRowDataNecessaryNull = false;
    /*
    for (let k = 0; k < this.rowDatas.length; k++) {
      if (this.rowDatas[k].isNecessary == 1 || this.rowDatas[k].isNecessary == 2 || this.rowDatas[k].isNecessary == 3) {
        if (this.rdata[k] == null || this.rdata[k].length == 0) isRowDataNecessaryNull = true;
      }
    }
    */
    const mappings: any[] = [];

    let j = 0;
    for (let i = 0; i < this.rdata.length; i++) {
      if (!isNaN(this.rdata[i]) && this.rdata[i] !== 0 && (this.rdata[i] + '').length > 0) {
        // 0は未定義なので無視
        const array = {
          uploadItemId: this.rowDatas[i].uploadItemId,
          mappedColmun: this.rdata[i] - 1,
          uploadItemCode: this.rowDatas[i].uploadItemCode
        };
        mappings[j] = array;
        j++;
      }
    }

    for (let k = 0; k < this.rowDatas.length; k++) {
      if (this.rowDatas[k].isNecessary === 1) {
        // 必須チェック付き
        const matchData = mappings.filter(function (item, index) {
          // tslint:disable-next-line:triple-equals
          if (item.uploadItemId == this) {
            return true;
          }
        }, this.rowDatas[k].uploadItemId);

        if (matchData.length === 0) {
          isRowDataNecessaryNull = true;
        }
      }

      if (this.rowDatas[k].isNecessary === 2 && this.uploadobjects.objectCode === 'arriveplans') {
        // 入荷データ(arriveplans)
        // カートン数(caseNr)か、個数(pcsNr)のどちらかが必須

        const matchData_ship1 = mappings.filter(function (item, index) {
          // tslint:disable-next-line:triple-equals
          if (item.uploadItemCode == this) {
            return true;
          }
        }, 'caseNr');

        const matchData_ship2 = mappings.filter(function (item, index) {
          // tslint:disable-next-line:triple-equals
          if (item.uploadItemCode == this) {
            return true;
          }
        }, 'pcsNr');

        if (matchData_ship1.length === 0 && matchData_ship2.length === 0) {
          isRowDataNecessaryNull = true;
        }
      }

      if (this.rowDatas[k].isNecessary === 2 && this.uploadobjects.objectCode === 'ship') {
        // 出荷データ(ship)
        // 届先住所 届先コードを指定するか、届先名称、届先郵便番号、届先住所1を指定

        const matchData_ship1 = mappings.filter(function (item, index) {
          // tslint:disable-next-line:triple-equals
          if (item.uploadItemCode == this) {
            return true;
          }
        }, 'dtaddressCd');

        if (matchData_ship1.length === 0) {
          // 届先コードがない

          // 届先名称
          const matchData_ship2 = mappings.filter(function (item, index) {
            // tslint:disable-next-line:triple-equals
            if (item.uploadItemCode == this) {
              return true;
            }
          }, 'dtnameTx');
          // 届先郵便番号
          const matchData_ship3 = mappings.filter(function (item, index) {
            // tslint:disable-next-line:triple-equals
            if (item.uploadItemCode == this) {
              return true;
            }
          }, 'dtpostalCd');
          // 届先住所1
          const matchData_ship4 = mappings.filter(function (item, index) {
            // tslint:disable-next-line:triple-equals
            if (item.uploadItemCode == this) {
              return true;
            }
          }, 'dtaddress1Tx');
          // 届先電話番号
          const matchData_ship5 = mappings.filter(function (item, index) {
            if (item.uploadItemCode == this) {
              return true;
            }
          }, 'dttelTx');

          if (matchData_ship2.length === 0 || matchData_ship3.length === 0 || matchData_ship4.length === 0 || matchData_ship5.length === 0) {
            isRowDataNecessaryNull = true;
          }
        }
      }

      if (this.rowDatas[k].isNecessary === 3 && this.uploadobjects.objectCode === 'ship') {
        // 出荷データ(ship)
        // カートン数(shipcaseNr)か、個数(shipbaraNr)のどちらかが必須

        const matchData_ship1 = mappings.filter(function (item, index) {
          // tslint:disable-next-line:triple-equals
          if (item.uploadItemCode == this) {
            return true;
          }
        }, 'shipcaseNr');

        const matchData_ship2 = mappings.filter(function (item, index) {
          // tslint:disable-next-line:triple-equals
          if (item.uploadItemCode == this) {
            return true;
          }
        }, 'shipbaraNr');

        if (matchData_ship1.length === 0 && matchData_ship2.length === 0) {
          isRowDataNecessaryNull = true;
        }
      }
    }
    // console.log(isRowDataNecessaryNull)
    this.isSubmitButtonEnabled = this.patternNameCls === 'active' && this.loadStartAtCls === 'active' && !isRowDataNecessaryNull;
  }

  onCustomerSelectChange(rowData, index) {
    this.errorInfo = '';
    this.rowDatasCls[index] = this.rdata[index] === '' ? '' : 'active';
  }

  registerLayoutContentScrollListener() {
    this.scrollContent.nativeElement.addEventListener('scroll', event => {
      this.isShowFloatDesc = this.scrollContent.nativeElement.scrollTop > 550;
    });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa0Common/wa0052/wa0052.component.ts